export default [20, 50, 100]